import { render, staticRenderFns } from "./ModalEstudiante.vue?vue&type=template&id=430c7473&"
import script from "./ModalEstudiante.vue?vue&type=script&lang=js&"
export * from "./ModalEstudiante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports